import React from "react";
import DropdownMenu from "./DropdownMenu";

interface VersionProps {
  changeVersion: (version: string) => void;
  versions: string[];
  apiVersion: string;
}

export const VersionSelector: React.FC<VersionProps> = ({ changeVersion, versions, apiVersion }) => {
  return (
    <DropdownMenu
      label=""
      items={versions}
      selectedItem={apiVersion}
      onSelect={changeVersion}
    />
  );
};
